"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBucketsInput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=ListBucketsInput.js.map